import { combineReducers } from 'redux';

import user from './user/reducer';
import calendar from './calendar/reducer';
import menu from './menu/reducer';
import cart from './cart/reducer';
import feedback from './feedback/reducer';
import setting from './setting/reducer';
import app from './app/reducer';

export default combineReducers({
	user,
	calendar,
	menu,
	cart,
	feedback,
	setting,
	app,
});
